import { createPaginatedRandomClinicalTrialsList, createRandomClinicalTrialDetail } from '../../mocks/clinicalTrialsList';
import { ClinicalTrialRequestType, ClinicalTrialType } from '@dynamika-shared/types/clinicalTrials';
import {  axiosMock, RESTClient } from '../client';
import { API_URL } from '../apiDictionary';


type PaginatedArgs = {
  page?: number;
  size?: number;
};

export const fetchClinicalTrialsListMock = async (args?: PaginatedArgs) => {
  const data = createPaginatedRandomClinicalTrialsList(50, {
    page: args?.page ?? 1,
    size: args?.size ?? 10,
  });

  axiosMock.onGet(API_URL.clinicalTrial).reply(200, data);
  axiosMock.onGet(API_URL.clinicalTrial, {
    params: {
      page: args?.page,
      size: args?.size,
    },
  });
};
export const fetchClinicalTrialMock = async (id: string) => {
  const data = createRandomClinicalTrialDetail(id);
  axiosMock.onGet(/\/clinical-trials\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?$/).reply(200, data);
};
export const updateClinicalTrialMock = async () => {
  axiosMock.onPut(/\/clinical-trials\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?$/).reply(200);
};

export const createClinicalTrial = async (body: ClinicalTrialRequestType) => {
  return RESTClient.post<ClinicalTrialType>(API_URL.clinicalTrial, body);
};
